import countryData from "../assets/geographies/countries_states.json";
import {
  findWhere,
  flatten,
  isArray,
  isEmpty,
  pluck,
  reject,
  some,
} from "underscore";

const coreCountryData = countryData.map((country) => {
  return {
    name: country.name,
    isoCode: country.iso2,
  };
});

const getAllStateData = () => flatten(pluck(countryData, "states"));

const getStates = (countryIsoCodes = ["US"]) => {
  const states = [];

  if (isArray(countryIsoCodes)) {
    for (const countryIsoCode of isEmpty(countryIsoCodes) ?
      ["US"] :
      countryIsoCodes) {
      const countryData = getCountryData(countryIsoCode, false);
      states.push(...countryData.states);
    }
  } else {
    states.push(...getCountryData(countryIsoCodes, false).states);
  }

  return states;
};

const getUSStatesWithDCOnly = (controlledFields) => {
  const countryCondition = findWhere(controlledFields, {
    fieldType: "Country",
  });
  const countriesIncludeUS = some(countryCondition?.value, (value) => {
    if (value?.isoCode === "US") {
      return true;
    }
    return false;
  });
  if (!isEmpty(countryCondition) && !countriesIncludeUS) {
    return null;
  }
  const states = getStates();
  return reject(states, (state) =>
    [
      "AS",
      "GU",
      "MP",
      "PR",
      "UM",
      "UM-67",
      "UM-71",
      "UM-76",
      "UM-79",
      "UM-81",
      "UM-84",
      "UM-86",
      "UM-89",
      "UM-95",
      "VI",
    ].includes(state.state_code),
  );
};

const getCountryData = (isoCode, onlyCoreData = true) => {
  if (onlyCoreData) {
    return findWhere(coreCountryData, {isoCode: isoCode});
  } else {
    return findWhere(countryData, {iso2: isoCode});
  }
};

const getStateData = (stateCode, countryCode) => {
  const countryData = getCountryData(countryCode, false);
  return findWhere(countryData.states, {state_code: stateCode});
};

const getStateById = (stateId) => {
  for (const country of countryData) {
    const foundState = findWhere(country.states, {id: parseInt(stateId, 10)});
    if (!isEmpty(foundState)) {
      return {countryIsoCode: country.iso2, ...foundState};
    }
  }
};

export {
  countryData,
  coreCountryData,
  getAllStateData,
  getStates,
  getUSStatesWithDCOnly,
  getCountryData,
  getStateData,
  getStateById,
};
